import script from "./SubscribeSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscribeSection.vue?vue&type=script&setup=true&lang=js"

import "./SubscribeSection.vue?vue&type=style&index=0&id=a37875f4&lang=scss"

const __exports__ = script;

export default __exports__